export const SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large'
};
